// Third party dependencies.
import React from 'react';
import { Image } from 'react-native';
import JazzIcon from 'react-native-jazzicon';

// External dependencies.
import AvatarBase from '../../foundation/AvatarBase';
import { AvatarSize } from '../../Avatar.types';
import { toDataUrl } from '../../../../../../utils/blockies';

// Internal dependencies.
import { AvatarAccountProps, AvatarAccountType } from './AvatarAccount.types';
import stylesheet from './AvatarAccount.styles';

const AvatarAccount = ({
  type = AvatarAccountType.JazzIcon,
  accountAddress,
  size = AvatarSize.Md,
  style,
  ...props
}: AvatarAccountProps) => {
  if (!accountAddress) return null;
  return (
    <AvatarBase size={size} style={style} {...props}>
      {
        {
          [AvatarAccountType.JazzIcon]: (
            <JazzIcon size={Number(size)} address={accountAddress} />
          ),
          [AvatarAccountType.Blockies]: (
            <Image
              source={{ uri: toDataUrl(accountAddress) }}
              style={stylesheet.imageStyle}
            />
          ),
        }[type]
      }
    </AvatarBase>
  );
};

export default AvatarAccount;

export { AvatarAccount };
